/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Center, HStack, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, Text, } from "@reverb-ui/react";
// import User from "@/assets/icons/user.svg";
import { Person } from "@reverb-ui/icons-react";
import React from "react";
var RoleAlertModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onSubmit = _a.onSubmit, role = _a.role;
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, size: "xl" },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalBody, { overflow: "auto" },
                React.createElement(Center, { my: "8" },
                    React.createElement(Person, null)),
                React.createElement(Text, { align: "center", marginTop: "30px" },
                    React.createElement(Text, { fontSize: "22px", as: "strong" },
                        "Change to ",
                        role,
                        "?"),
                    React.createElement(Text, { fontSize: "14px", marginTop: "30px" },
                        "By confirming, this user will be a ",
                        role,
                        " of this company."))),
            React.createElement(ModalFooter, { alignSelf: "center", marginTop: "30px" },
                React.createElement(HStack, { spacing: 4, align: "center" },
                    React.createElement(Button, { borderColor: "blue.500", variant: "outline", colorScheme: "blue", color: "blue.500", onClick: onClose, title: "Cancel" }, "Cancel"),
                    React.createElement(Button, { colorScheme: "blue", onClick: onSubmit, title: "Confirm" }, "Confirm"))))));
};
export default RoleAlertModal;
